import React from 'react';
import Layout from '../components/Layout';

const NotFound = () => (
  <Layout>
  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '70vh' }}>
    <h1 style={{ fontSize: '5rem', color: '#e74c3c' }}>404</h1>
    <h2>Page Not Found</h2>
    <p>The page you are looking for does not exist or has been moved.</p>
  </div>
  </Layout>
);

export default NotFound;
